import { render, staticRenderFns } from "./TheRanking.vue?vue&type=template&id=c90e3dca&scoped=true&lang=pug&"
import script from "./TheRanking.vue?vue&type=script&lang=js&"
export * from "./TheRanking.vue?vue&type=script&lang=js&"
import style0 from "./TheRanking.vue?vue&type=style&index=0&id=c90e3dca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c90e3dca",
  null
  
)

export default component.exports